import type { DeploymentRequestResourceReadBffV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { DeploymentRequestResource } from '../../../models/deployment/deploymentById.model';
import { toIsoStringIfDate } from '../../utils/date.utils';

function mapTrigger(
  trigger: NonNullable<DeploymentRequestResourceReadBffV2Api['trigger']>,
): DeploymentRequestResource['trigger'] {
  const mappedScheduleOption = trigger?.scheduleOption
    ? {
        date: toIsoStringIfDate(trigger.scheduleOption.date),
        daysOfWeek: trigger.scheduleOption.daysOfWeek ?? [],
        exclusionDates: trigger.scheduleOption.exclusionDates?.map((date) => toIsoStringIfDate(date)),
        maxNoOfDeployments: trigger.scheduleOption.maxNoOfDeployments,
        timeSlot: trigger.scheduleOption.timeSlot
          ? {
              startDate: toIsoStringIfDate(trigger.scheduleOption.timeSlot.startDate),
              endDate: toIsoStringIfDate(trigger.scheduleOption.timeSlot.endDate),
            }
          : undefined,
      }
    : undefined;

  return {
    type: trigger.type as DeploymentRequestResource['trigger']['type'],
    scheduleOption: mappedScheduleOption,
  };
}

export function mapGetDeploymentRequestById(body: DeploymentRequestResourceReadBffV2Api): DeploymentRequestResource {
  return {
    ...body,
    creationDate: toIsoStringIfDate(body.creationDate),
    endDate: toIsoStringIfDate(body.endDate),
    startDate: toIsoStringIfDate(body.startDate),
    trigger: mapTrigger(body.trigger as NonNullable<DeploymentRequestResourceReadBffV2Api['trigger']>),
    options: {
      ...body.options,
      configuration: body.options?.configuration
        ? {
            ...body.options.configuration,
            custom: body.options.configuration.custom
              ? {
                  ...body.options.configuration.custom,
                  creationDate: toIsoStringIfDate(body.options.configuration.custom.creationDate),
                  updateDate: toIsoStringIfDate(body.options.configuration.custom.updateDate),
                }
              : undefined,
          }
        : undefined,
    },
  };
}
